import MButton from './MButton.vue';

MButton.install = (app) => {
  app.component('MButton', MButton);
};

export { MButton };
